<template>
  <div class="premium-message-send">
    <PremiumMessageSendComplete
      v-if="showComplete"
      :fromUserImageUrl="fromUserIconUrl"
      :toUserImageUrl="userIconUrl"
      @close="handleCompleteClose"
    />
    <PremiumMessageSendConfirm
      v-else-if="showConfirm"
      :userIdTo="user.id"
      :message="message"
      :event-group-id="eventGroupId"
      @prev="handleConfirmBack"
      @send="handleConfirmSend"
    />
    <template v-else>
      <div class="message-send-scrollable">
        <div class="close" @click="close">
          <i class="bi bi-x"></i>
        </div>
        <div class="heading">
          {{ headingText }}
        </div>
        <div class="user">
          <img :src="userIconUrl" alt="ユーザアイコン" class="user-icon" />
          <div class="user-name">{{ userName }}</div>
          <button type="button" class="view-profile-button" @click="showProfile">
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.5023 15.577C13.6355 15.577 14.5979 15.1804 15.3896 14.3872C16.1812 13.5941 16.5771 12.6309 16.5771 11.4978C16.5771 10.3646 16.1805 9.40217 15.3873 8.6105C14.5942 7.81883 13.631 7.423 12.4978 7.423C11.3647 7.423 10.4022 7.81958 9.61058 8.61275C8.81891 9.40592 8.42307 10.3691 8.42307 11.5023C8.42307 12.6354 8.81966 13.5978 9.61282 14.3895C10.406 15.1812 11.3692 15.577 12.5023 15.577ZM12.5001 14.2C11.7501 14.2 11.1126 13.9375 10.5876 13.4125C10.0626 12.8875 9.80007 12.25 9.80007 11.5C9.80007 10.75 10.0626 10.1125 10.5876 9.5875C11.1126 9.0625 11.7501 8.8 12.5001 8.8C13.2501 8.8 13.8876 9.0625 14.4126 9.5875C14.9376 10.1125 15.2001 10.75 15.2001 11.5C15.2001 12.25 14.9376 12.8875 14.4126 13.4125C13.8876 13.9375 13.2501 14.2 12.5001 14.2ZM12.5013 18.5C10.2018 18.5 8.10657 17.8657 6.21557 16.597C4.32457 15.3285 2.93224 13.6295 2.03857 11.5C2.93224 9.3705 4.32407 7.6715 6.21407 6.403C8.10424 5.13433 10.1992 4.5 12.4988 4.5C14.7983 4.5 16.8936 5.13433 18.7846 6.403C20.6756 7.6715 22.0679 9.3705 22.9616 11.5C22.0679 13.6295 20.6761 15.3285 18.7861 16.597C16.8959 17.8657 14.801 18.5 12.5013 18.5ZM12.5001 17C14.3834 17 16.1126 16.5042 17.6876 15.5125C19.2626 14.5208 20.4667 13.1833 21.3001 11.5C20.4667 9.81667 19.2626 8.47917 17.6876 7.4875C16.1126 6.49583 14.3834 6 12.5001 6C10.6167 6 8.88757 6.49583 7.31257 7.4875C5.73757 8.47917 4.53341 9.81667 3.70007 11.5C4.53341 13.1833 5.73757 14.5208 7.31257 15.5125C8.88757 16.5042 10.6167 17 12.5001 17Z" fill="#5538EE"/>
            </svg>
            相手のプロフィールを確認
          </button>
          <div class="view-profile-note">
            下書きはそのまま残ります
          </div>
        </div>
        <div class="message">
          <div class="message-note">
            プレミアムメッセージはあなたの想いをしっかり伝えるために100文字以上必要です
          </div>
          <div class="message-textarea-wrapper">
            <textarea
              v-model="message"
              class="message-textarea"
              rows="5"
              placeholder="テキストエリア"
              @input="handleDraftChange"
            />
            <div class="message-textarea-counter">{{ characterCount }}/500</div>
          </div>
          <div class="message-caution">
            SNSのID等連絡先の入力は送信できません。
          </div>
          <div v-if="isOverLimit" class="message-error">
            500文字以内で入力してください。
          </div>
        </div>
      </div>
      <div class="message-send-actions">
        <button
          type="button"
          class="confirm-button"
          :class="isDisabledConfirm && 'disabled'"
          :disabled="isDisabledConfirm"
          @click="confirm"
        >
          確認する
        </button>
      </div>
      <div v-if="showDiscardModal" class="discard-modal-backdrop">
        <div class="discard-modal">
          <img :src="userIconUrl" alt="ユーザアイコン" class="user-icon user-icon-small" />
          <div class="discard-modal-title">
            途中のメッセージ内容は破棄されます
          </div>
          <div class="discard-modal-actions">
            <button type="button" class="discard-button" @click="confirmDiscard">
              削除する
            </button>
            <button type="button" class="cancel-button" @click="cancelDiscard">
              メッセージに戻る
            </button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import PremiumMessageSendConfirm from './PremiumMessageSendConfirm.vue'
import PremiumMessageSendComplete from './PremiumMessageSendComplete.vue'

export default {
  emits: ['close', 'show-profile', 'draft-change', 'completed'],
  components: {
    PremiumMessageSendConfirm,
    PremiumMessageSendComplete,
  },
  data() {
    return {
      message: '',
      showDiscardModal: false,
      showConfirm: false,
      showComplete: false,
    }
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    draftMessage: {
      type: String,
      default: '',
    },
    loginUser: {
      type: Object,
      default: () => ({}),
    },
    eventGroupId: {
      type: Number,
      default: null,
    },
  },
  watch: {
    draftMessage: {
      immediate: true,
      handler(newVal) {
        if (typeof newVal === 'string' && newVal !== this.message) {
          this.message = newVal
        }
      },
    },
  },
  computed: {
    characterCount() {
      return this.message.length
    },
    isOverLimit() {
      return this.characterCount > 500
    },
    isDisabledConfirm() {
      return this.characterCount < 100 || this.characterCount > 500;
    },
    userName() {
      return this.user && this.user.name ? this.user.name : ''
    },
    userIconUrl() {
      return this.user && this.user.icon_url
        ? this.user.icon_url
        : '/images/icon/apple-touch-icon.png'
    },
    fromUserIconUrl() {
      return this.loginUser && this.loginUser.icon_url
        ? this.loginUser.icon_url
        : '/images/icon/apple-touch-icon.png'
    },
    isEventContext() {
      return !!this.eventGroupId
    },
    headingText() {
      return this.isEventContext
        ? 'イベント限定プレミアムメッセージを送る'
        : 'プレミアムメッセージを送る'
    },
  },
  methods: {
    close() {
      if (this.showComplete) {
        this.handleCompleteClose()
        return
      }
      if (this.showConfirm) {
        this.showConfirm = false
        return
      }
      if (this.characterCount > 0) {
        this.showDiscardModal = true
        return
      }
      this.$emit('close')
    },
    showProfile() {
      this.$emit('show-profile', this.message)
    },
    confirm() {
      if (this.isDisabledConfirm) {
        return
      }
      this.showDiscardModal = false
      this.showConfirm = true
    },
    confirmDiscard() {
      this.message = ''
      this.showDiscardModal = false
      this.$emit('close')
    },
    cancelDiscard() {
      this.showDiscardModal = false
    },
    handleConfirmBack() {
      this.showConfirm = false
    },
    handleConfirmSend() {
      this.showConfirm = false
      this.showComplete = true
    },
    handleCompleteClose() {
      this.message = ''
      this.showConfirm = false
      this.showDiscardModal = false
      this.showComplete = false
      this.$emit('completed')
      this.$emit('close')
    },
    handleDraftChange() {
      this.$emit('draft-change', this.message)
    },
  }
}
</script>

<style scoped>
.premium-message-send {
  position: fixed;
  top: 0;
  left: 50%;
  width: 100%;
  max-width: 540px;
  height: 100vh;
  min-height: 100vh;
  transform: translateX(-50%);
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

@supports (height: 100dvh) {
  .premium-message-send {
    height: 100dvh;
    min-height: 100dvh;
  }
}

@supports (-webkit-touch-callout: none) and (not (height: 100dvh)) {
  .premium-message-send {
    height: -webkit-fill-available;
    min-height: -webkit-fill-available;
  }
}

.message-send-scrollable {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 24px;
}

.message-send-actions {
  flex: 0 0 auto;
  padding: 16px;
  padding-bottom: 16px;
  background: #fff;
}

@supports (padding-bottom: calc(env(safe-area-inset-bottom) + 16px)) {
  .message-send-actions {
    padding-bottom: calc(env(safe-area-inset-bottom) + 16px);
  }
}

.close {
  padding: 8px 12px;
  border-bottom: 1px solid #efeef0;
  cursor: pointer;
}

.close .bi-x {
  font-size: 36px;
}

.heading {
  margin: 16px 16px 0;
  font-size: 24px;
  font-weight: 700;
}

.user {
  padding: 24px 0 96px;
  margin: 0 -12px;
  background: url(/images/premium_message/send-message-user.png);
  background-size: 112%;
  background-position: center 8%;
  background-repeat: no-repeat;
  text-align: center;
}

.user-icon {
  width: 84px;
  height: 84px;
  border-radius: 42px;
}

.user-icon-small {
  width: 54px;
  height: 54px;
}

.user-name {
  margin: 8px 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
}

.view-profile-button {
  width: 248px;
  padding: 8px;
  background-color: #fff;
  color: #5538ee;
  font-size: 14px;
  font-weight: 700;
  border: 1px solid #dadadd;
  border-radius: 10px;
}

.view-profile-note {
  margin-top: 8px;
  color: #5538ee;
  font-size: 11px;
  line-height: 1.5;
}

.message {
  padding: 8px 16px 16px;
}

.message-note {
  font-size: 12px;
  font-weight: 700;
}

.message-textarea-wrapper {
  position: relative;
  padding-bottom: 32px;
  margin-top: 8px;
  overflow: hidden;
  border: 1px solid #dadadd;
  border-radius: 10px;
}

.message-textarea {
  width: 100%;
  padding: 16px;
  border: 0;
  line-height: 1.6;
  resize: none;
}

.message-textarea:focus {
  outline: none;
}

.message-textarea-counter {
  position: absolute;
  right: 20px;
  bottom: 12px;
  padding: 0 4px;
  background-color: #fff;
  color: #777681;
  font-size: 12px;
}

.message-caution {
  margin-top: 4px;
  color: #27272a;
  font-size: 11px;
}

.message-error {
  margin-top: 8px;
  color: #ef4444;
  font-size: 12px;
}

.confirm-button {
  width: 100%;
  padding: 16px;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  background-color: #5538ee;
  border: 0;
  border-radius: 16px;
  cursor: pointer;
}

.confirm-button.disabled {
  background-color: #e4e4e6;
  color: #94939d;
  cursor: not-allowed;
}

.discard-modal-backdrop {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.4);
  padding-top: 60px;
  overflow-y: auto;
}

.discard-modal {
  width: calc(100% - 64px);
  max-width: 320px;
  padding: 24px 20px;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  text-align: center;
}

.discard-modal-title {
  margin: 8px 0 16px;
  color: #1f2937;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
}

.discard-modal-actions {
  display: flex;
  gap: 8px;
}

.discard-button {
  width: 131px;
  padding: 12px 0;
  color: #5538ee;
  font-size: 14px;
  font-weight: 700;
  background-color: #fff;
  border: 1px solid #dadadd;
  border-radius: 10px;
  cursor: pointer;
}

.cancel-button {
  width: 131px;
  padding: 12px 0;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  background-color: #5538ee;
  border: 0;
  border-radius: 10px;
  cursor: pointer;
}
</style>
